import React, { Component } from 'react';
import { postVUEventRegistrationForm, postVUEventCodeForm } from '../../../apis/forms';
import { getPlacesToBuyByState } from '../../../apis/dealers';
import toast from '../../../components/toast';
import { yesNo, usStates, canadaProvinces } from '../../../helpers/shared-form-data.json';
import { addParamsToUrl } from '../../../utils/';
import kebabCase from 'lodash/kebabCase';
import LoaderSection from '../loader-section.jsx';

class VollrathUniversityEventRegistrationForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            registered: this.props.registered,
            isAuthenticated: this.props.isAuthenticated,
            eventCode: this.props.eventCode,
            firstName: this.props.contact.FirstName,
            lastName: this.props.contact.LastName,
            email: this.props.userEmail,
            company: 'Select your dealer',
            customCompany: '',
            jobFunction: 'Purchasing/Buyer',
            jobTitle: this.props.contact.Title,
            dealer: this.props.dealer,
            cellPhoneNumber: this.props.contact.PhoneNumber,
            address: this.props.contact.Street,
            city: this.props.contact.City,
            state: this.props.contact.State,
            zipcode: this.props.contact.ZipCode,
            country: 'United States of America',
            title: this.props.title,
            over21: '',
            medicalIssues: '',
            dietaryRestrictions: '',
            badgeName: '',
            badgeNameConfirm: '',
            emergencyContactName: '',
            emergencyContactPhone: '',
            isSending: true,
            countries: [],
            states: [],
            provinces: [],
            errors: [],
            jobFunctions: [],
            submit: false,
            eventId: '',
            validCode: false,
            eventFull: false,
            redirectPath: '',
            dealers: [],
            redirected: false,
            deadlineReached: this.props.deadlineReached,
            deadlineReachedText: this.props.deadlineReachedText,
            disclaimer: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    componentDidMount() {
        console.log('Deadline reached: ' + this.state.deadlineReached)
        this.getSelectBoxData();
        this.getCountryAndStates();

        if (this.state.eventCode) {
            this.submitEventCode();
        }

        if (document.referrer.includes("account")) {
            toast.success("Thank you for logging in");
        }

        this.setState({
            isSending: false
        });
    }

    getCountryAndStates() {

        const states = usStates;
        const provinces = canadaProvinces;

        const currentStates = this.state.country === "United States of America" ?
            states : provinces;

        const userState = usStates.filter(s =>
            s.name === this.state.state);

        let newState = 'AL';

        if (userState[0]) {
            newState = userState[0].abbreviation;
        }

        this.setState({
            states: currentStates,
            state: newState
        });
    }

    getSelectBoxData() {
        const countries = ["United States of America", "Canada"];
        const functions = [
            'Purchasing/Buyer', 'Decision Maker/Influencer', 'Research and Development', 'Sales',
            'Marketing/Merchandising', 'Repair Services', 'Customer Service'
        ];
      

        this.setState({
            countries: countries,
            jobFunctions: functions
        });
    }

    handleFormSubmit(e) {
        e.preventDefault();

        if (!this.state.isSending) {
            this.setState({
                isSending: true,
                errors: [],
                submit: true
            });

            e.target.id === "event-code-form" ?
                this.submitEventCode() :
                this.submitRegistrationForm();
        }
    }

    getDealers() {
        getPlacesToBuyByState({
            state: this.state.state,
            nodeId: 20773

        })
            .then(data => {
                var dealers = data;
                if (dealers) {
                    this.setState({
                        dealers: dealers
                    });

                }
                else {
                    this.setState({
                        company: 'Could not find'
                    });
                }

            })

            .catch(error => {
                console.log(error);
            });
    }

    submitEventCode() {
        postVUEventCodeForm({
            eventCode: this.state.eventCode
        })
            .then(json => {
                console.log(json);
                this.setState({
                    isSending: false
                });

                if (json.success) {
                    this.setState({
                        eventId: json.successInfo.eventGUID,
                        validCode: json.successInfo.validCode,
                        eventFull: json.successInfo.eventFull,
                        redirectPath: json.successInfo.redirectPath
                    });
                    if (json.successInfo.redirectPath && window.location.pathname !== json.successInfo.redirectPath) {
                        window.location = addParamsToUrl(json.successInfo.redirectPath, { eventcode: this.state.eventCode });
                        this.setState({ redirected: true });
                    }
                    else {
                        history.pushState(null, document.title, addParamsToUrl(window.location.pathname, { eventcode: this.state.eventCode }));
                    }
                }
                else {
                    this.setState({
                        errors: json.errors,
                        submit: false
                    });

                }
            })
            .catch(error => {
                this.setState({
                    isSending: false,
                    submit: false
                });
                console.log(error);
                toast.error('There was an issue sending your request. Please try again soon.');
            });
    }

    submitRegistrationForm() {
        if (this.state.badgeName !== this.state.badgeNameConfirm) {
            this.setState({
                isSending: false
            });
            toast.error('Please make sure badge names match.');
            return false;
        }

        if (!this.state.disclaimer) {
            this.setState({
                isSending: false
            });
            toast.error('Please accept the disclaimer');
            return false;
        }

        if (this.state.customCompany !== '') {
            this.state.company = this.state.customCompany;
        }

        const currentUrl = window.location.href;

        postVUEventRegistrationForm({
            eventGuid: this.state.eventId,
            eventUrl: currentUrl,
            eventTitle: this.state.title,
            eventCode: this.state.eventCode,
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            company: this.state.company,
            jobFunction: this.state.jobFunction,
            jobTitle: this.state.jobTitle,
            dealer: this.state.dealer,
            cellPhoneNumber: this.state.cellPhoneNumber,
            address: this.state.address,
            city: this.state.city,
            state: this.state.state,
            zipcode: this.state.zipcode,
            country: this.state.country,
            over21: this.state.over21,
            medicalIssue: this.state.medicalIssues,
            dietaryRestrictions: this.state.dietaryRestrictions,
            badgeName: this.state.badgeName,
            badgeNameConfirm: this.state.badgeNameConfirm,
            emergencyContactName: this.state.emergencyContactName,
            emergencyContactPhone: this.state.emergencyContactPhone,
            pageName: this.props.pageName,
            disclaimer: this.state.disclaimer
        })
            .then(json => {
                console.log(json);
                this.setState({
                    isSending: false
                });

                if (json.success) {

                    if (this.props.redirectTo) {
                        this.setState({ submit: true });
                        toast.success('Your request has been submitted!');
                        window.location = window.location.href;
                    }
                    else {
                        this.setState({
                            eventCode: '',
                            firstName: '',
                            lastName: '',
                            email: '',
                            company: 'Select your dealer',
                            jobFunction: 'Purchasing/Buyer',
                            jobTitle: '',
                            dealer: 'Not Needed',
                            cellPhoneNumber: '',
                            address: '',
                            city: '',
                            state: '',
                            zipcode: '',
                            country: 'United States of America',
                            over21: '',
                            medicalIssues: '',
                            dietaryRestrictions: '',
                            badgeName: '',
                            badgeNameConfirm: '',
                            emergencyContactName: '',
                            emergencyContactPhone: '',
                            submit: false,
                            disclaimer: false
                        });
                    }
                }
                else {
                    this.setState({
                        errors: json.errors,
                        submit: false
                    });
                    const newErrors =
                        json.errors.map((error, index) =>
                            `${error} `
                        );
                    toast.error(newErrors.toString().replace(',', ' '));
                }
            })
            .catch(error => {
                this.setState({
                    isSending: false,
                    submit: false
                });
                console.log(error);
                toast.error('There was an issue sending your request. Please try again soon.');
            });
    }

    phoneNumberAutoFormat(phoneNumber){
        const number = phoneNumber.trim().replace(/[^0-9]/g, "");

        if (number.length < 4) return number;
        if (number.length < 7) return number.replace(/(\d{3})(\d{1})/, "$1-$2");
        if (number.length < 11) return number.replace(/(\d{3})(\d{3})(\d{1})/, "$1-$2-$3");
        return number.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
    };

    handleChange(e) {
        const target = e.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        if (target.type === 'tel') {
            this.setState({
                [name]: this.phoneNumberAutoFormat(value),
                errors: []
            });
        } else {
            this.setState({
                [name]: value,
                errors: []
            },
                () => {
                    if (name === "country") {
                        this.getCountryAndStates();
                    }

                    if (name === "state") {
                        this.getDealers();
                    }
                });
        }

      
    }

    _renderDisclaimer() {
        let disclaimer =
            <p className="disclaimer-text"> The Vollrath Company reserves the right to use any photograph/video taken at any event sponsored by The Vollrath Company, without the expressed written permission of those included within the photograph/video. The Vollrath Company may use the photograph/video in publications or other media material produced, used or contracted by The Vollrath Company including but not limited to: brochures, invitations, books, newspapers, magazines, television, websites, etc.
                <br />
                <br/>
                To ensure the privacy of individuals and children, images will not be identified using full names or personal identifying information without written approval from the photographed subject, parent or legal guardian.
                <br />
                <br />
                A person attending an event who does not wish to have their image recorded for distribution should make their wishes known to the photographer, and/or the event organizers, and/or contact The Vollrath Company at 1-800-624-2051 of his/her intentions and include a photograph. The Vollrath Company will use the photo for identification purposes and will hold it in confidence.
                <br />
                <br />
                By participating in a The Vollrath Company event or by failing to notify The Vollrath Company your desire to not have your photograph used by The Vollrath Company, you are agreeing to release, defend, hold harmless and indemnify The Vollrath Company from any and all claims involving the use of your picture or likeness.
                <br />
                <br />
                Any person or organization not affiliated with The Vollrath Company may not use, copy, alter or modify The Vollrath Company photographs, graphics, videography or other, similar reproductions or recordings without the advance written permission of an authorized designee from The Vollrath Company.
                </p>;
        
        return (
            disclaimer
        );
    }



    render() {
        let errors, validated, registrationForm;
        if (this.state.errors && this.state.errors.length) {
            errors = <ul className="error-list">
                {this.state.errors.map((error) => (
                    <li>{error}</li>
                ))}
            </ul>;
        }

        if (this.state.isSending) {
            registrationForm = <LoaderSection show={true} />;
        }

        validated = this.state.badgeName !== '' && this.state.badgeNameConfirm !== '' && this.state.badgeName !== this.state.badgeNameConfirm ?
            'form-field-validated' : '';

        let validateMsg = this.state.badgeName !== '' && this.state.badgeNameConfirm !== '' && this.state.badgeName !== this.state.badgeNameConfirm ?
            <span>Please match this field with the badge name field</span> : <div></div>

        registrationForm = this.state.validCode &&
            !this.state.eventFull &&
            this.state.isAuthenticated !== "False" &&
            this.state.registered !== "True" &&
            this.state.deadlineReached !== "True" &&
            !this.state.redirected
            ? <div>
                <div>
                    <p id="form-registration-heading" className="intro-blk-subtitle">Please fill out the form below to register for this event.</p>
                </div>
                <form id="event-registration-form" action="#" method="post" onSubmit={this.handleFormSubmit} ref="">
                    <div id="top-of-form" className="row">
                        <div className="section-header form-step col-md-12">
                            <h2 className="section-title">Step 1 of 2:</h2>
                        </div>
                        <div className="section-header col-md-12">
                            <h3 className="section-title">Personal Information</h3>
                        </div>
                        <div className="col-md-12">
                            {errors}
                        </div>
                        <div className="form-group col-lg-4 col-md-6">
                            <label htmlFor="firstName">First Name *</label>
                            <input className="form-control" type="text" id="firstName" name="firstName" placeholder="John" required value={
                                this.state.firstName} onChange={this.handleChange} />
                        </div>
                        <div className="form-group col-lg-4 col-md-6">
                            <label htmlFor="lastName">Last Name *</label>
                            <input className="form-control" type="text" id="lastName" name="lastName" placeholder="Doe" required value={
                                this.state.lastName} onChange={this.handleChange} />
                        </div>
                        <div className="form-group col-lg-4 col-md-6">
                            <label htmlFor="cellPhoneNumber">Cell Phone Number *</label>
                            <input className="form-control" type="tel" minLength="10" maxLength="12" id="cellPhoneNumber" name="cellPhoneNumber" placeholder="123-123-1234" required value={
                                this.state.cellPhoneNumber} onChange={this.handleChange} />
                        </div>
                        <div className="form-group col-lg-4 col-md-6">
                            <label htmlFor="country">Country *</label>
                            <select className="form-control" id="country" name="country" value={this.state.country
                            } onChange={this.handleChange}>

                                {this.state.countries.map((country) => (
                                    <option value={country}>{country}</option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group col-lg-4 col-md-6">
                            <label htmlFor="address">Address</label>
                            <input className="form-control" type="text" id="address" name="address" placeholder="444 East Main Street" value={
                                this.state.address} onChange={this.handleChange} />
                        </div>

                        <div className="form-group col-lg-4 col-md-6">
                            <label htmlFor="city">City *</label>
                            <input className="form-control" type="text" id="city" name="city" required value={
                                this.state.city} onChange={this.handleChange} />
                        </div>
                        <div className="form-group col-lg-4 col-md-6">
                            <label htmlFor="state">State or Province *</label>
                            <select className="form-control" id="state" name="state" value={this.state.state
                            } onChange={this.handleChange}>
                                {this.state.states.map((state) => (
                                    <option value={state.abbreviation}>{state.name}</option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group col-lg-4 col-md-6">
                            <label htmlFor="zipcode">Postal Code *</label>
                            <input className="form-control" type="text" id="zipcode" name="zipcode" placeholder="12345" required="" value={
                                this.state.zipcode} onChange={this.handleChange} />
                        </div>

                        <div className="section-header col-md-12">
                            <h3 className="section-title">Company Information</h3>
                        </div>
                        <div className="form-group col-lg-4 col-md-6">
                            <label htmlFor="jobFunction">Job Function *</label>
                            <select className="form-control" id="jobFunction" name="jobFunction" required value={this
                                .state.jobFunction} onChange={this.handleChange}>
                                {this.state.jobFunctions.map((item) => (
                                    <option value={item}>{item}</option>
                                ))}
                            </select>
                        </div>
                        <div className="form-group col-lg-4 col-md-6">
                            <label htmlFor="jobTitle">Job Title *</label>
                            <input className="form-control" type="text" id="jobTitle" name="jobTitle" placeholder="Chef" required value={
                                this.state.jobTitle} onChange={this.handleChange} />
                        </div>
                        <div className="section-header col-md-12">
                            <h3 className="section-title">Event Information</h3>
                        </div>
                        <div className="form-group col-lg-4 col-md-6">
                            <span className="label">Are you 21 or older? *</span>
                            <ul className="radio-list">
                                {yesNo.map((item) => (
                                    <li>
                                        <input className="custom-radio" id={`over21${kebabCase(item)}`
                                        } name="over21" type="radio" required value={item} onChange={this.handleChange
                                        } />
                                        <label htmlFor={`over21${kebabCase(item)}`}>{item}</label>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="form-group col-lg-4 col-md-6">
                            <label htmlFor="medicalIssues">Any medical conditions we should be aware of? *</label>
                            <input className="form-control" type="text" id="medicalIssues" name="medicalIssues" required value={
                                this.state.medicalIssues} onChange={this.handleChange} />
                        </div>
                        <div className="form-group col-lg-4 col-md-6">
                            <label htmlFor="dietaryRestrictions">Any special dietary needs we should know about? *</label>
                            <input className="form-control" type="text" id="dietaryRestrictions" name="dietaryRestrictions" required value={
                                this.state.dietaryRestrictions} onChange={this.handleChange} />
                        </div>
                        <div className="form-group col-lg-4 col-md-6">
                            <label htmlFor="badgeName">Name as you would like it to appear on your badge *</label>
                            <input className="form-control" type="text" id="badgeName" name="badgeName" required value={
                                this.state.badgeName} onChange={this.handleChange} />
                        </div>
                        <div className="form-group col-lg-4 col-md-6">
                            <label className={validated
                            } htmlFor="badgeNameConfirm">Confirm your name for your badge *</label>
                            <input className={`form-control ${validated}`
                            } type="text" id="badgeNameConfirm" name="badgeNameConfirm" required value={this.state.badgeNameConfirm} onChange={
                                this.handleChange} />
                            {validateMsg}
                        </div>
                        <div className="form-group col-lg-4 col-md-6">
                            <label htmlFor="emergencyContactName">Name of emergency contact *</label>
                            <input className="form-control" type="text" id="emergencyContactName" name="emergencyContactName" required value={
                                this.state.emergencyContactName} onChange={this.handleChange} />
                        </div>
                        <div className="form-group col-lg-4 col-md-6">
                            <label htmlFor="emergencyContactPhone">Emergency Contact Phone Number *</label>
                            <input className="form-control" type="tel" minLength="10" maxLength="12" id="emergencyContactPhone" name="emergencyContactPhone" placeholder="123-123-1234" value={
                                this.state.emergencyContactPhone} onChange={this.handleChange} />
                        </div>

                        <div className="col-md-12">
                            <details className="panel-accordion">
                                <summary className="panel-accordion-title no-pad">Vollrath Photo and Video Disclaimer</summary>
                                <div>
                                    {this._renderDisclaimer()}
                                </div>
                            </details>

                            <div className="form-group form-group-flex">
                                <div className="form-actions">
                                    <input className="custom-checkbox square" value={this.state.disclaimer} onChange={
                                        this.handleChange} name="disclaimer" type="checkbox" id="disclaimer" />
                                    <label htmlFor="disclaimer">I agree with the disclaimer *</label>
                                </div>
                            </div>


                            <div className="btn-container">
                                <div className="form-actions margin-right-40">
                                    <button className="btn" disabled={this.state.isSending}>Send</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            : <div></div>;

        let eventCodeInput;
        if (!this.state.validCode &&
            this.state.eventId === '' &&
            this.state.registered !== "True" &&
            this.state.isAuthenticated === "True" && 
            this.state.deadlineReached !== "True") {
            eventCodeInput = 
                <form id="event-code-form" action="#" method="post" onSubmit={this.handleFormSubmit} ref="">
                    <div className="row justify-content-center event-code-input">

                        <div className="form-group col-md-4">
                            {errors}
                            <label htmlFor="eventCode">Enter your registration code *</label>
                            <input className="form-control" type="text"  minLength="9" id="eventCode" name="eventCode" required value={
                                this.state.eventCode} onChange={this.handleChange} />
                        </div>
                        <div className="form-actions col-md-12 justify-content-center">
                            <button className="btn" disabled={this.state.isSending}>Send</button>
                        </div>
                    </div>
                </form>;
        }
        else if (
            this.state.registered !== "True" &&
            this.state.deadlineReached === "True" &&
            this.state.isAuthenticated === "True")
        {
            eventCodeInput = <div className="cta-callout">
                <p className="cta-callout-title">{this.state.deadlineReachedText ? this.state.deadlineReachedText : 'This Live VU event signup deadline has passed or has reached capacity'}</p>
            </div>;
        }
        else if (this.state.isAuthenticated === "False") {
            eventCodeInput =
                <div className="cta-callout">
                    <p className="cta-callout-title">Please login to register for your event</p>
                    <a href="/account/signin" className="btn">Login</a>
                </div>;
        }


        return (
            <div>
                {eventCodeInput}
                {registrationForm}
            </div>
        );
    }
}

export default VollrathUniversityEventRegistrationForm;